import { render } from "./AsesoriaPlaneacion.vue?vue&type=template&id=707e56a4&scoped=true"
import script from "./AsesoriaPlaneacion.vue?vue&type=script&lang=js"
export * from "./AsesoriaPlaneacion.vue?vue&type=script&lang=js"

import "./AsesoriaPlaneacion.vue?vue&type=style&index=0&id=707e56a4&scoped=true&lang=css"

import exportComponent from "/Users/fasa/JS/freelance/UgaldeYAsociados/gerardoyasociados-website-final/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-707e56a4"]])

export default __exports__